/**
 * Central query key registry — keys live here rather than inline so
 * invalidation after a mutation cannot silently miss a cache entry because
 * two call sites spelled the key differently.
 */
export const queryKeys = {
  dashboardStats: ['dashboard', 'stats'] as const,
  users: (page: number, pageSize: number) => ['users', page, pageSize] as const,
  usersAll: ['users'] as const,
  plans: ['plans'] as const,
  me: ['me'] as const,
}
